import { isAdminSpaceUser } from '@/utils/accessControlUtils'
import {
  isPartnerOrAffilieUser,
  resolveTransferBillingIds,
} from '../../GestionTransferts/Reservations/transferBillingIds'
import {
  hasConfiguredTransferPayment,
  serializeTransferPaymentMethod,
} from '../../GestionTransferts/Reservations/transferPaymentStorage'
import { hasDailyStock } from '../shared/carteDisplay'

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}')
  } catch {
    return {}
  }
}

export const isAdminUser = () => {
  const u = readUser()
  return isAdminSpaceUser(u)
}

export const resolveClientName = (draft) => {
  const physiqueCombined = [draft.billing_nom, draft.billing_prenom]
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .filter(Boolean)
    .join(' ')
    .trim()

  if (draft.billing_client_kind === 'morale') {
    return String(draft.billing_nom || '').trim() || String(draft.client_name || '').trim()
  }
  if (draft.billing_client_kind === 'physique') {
    return physiqueCombined || String(draft.client_name || '').trim()
  }
  return String(draft.client_name || '').trim()
}

export const validateCaBillingDraft = (draft, t, options = {}) => {
  const err = {}
  const skipPayment = !!options.skipPayment
  const useHotelBilling = isAdminUser() && !isPartnerOrAffilieUser()
  const required = t ? t('cartesAcces.recherche.billing.required') : 'Requis'
  const selectClient = t ? t('cartesAcces.recherche.billing.selectClient') : 'Sélectionnez un client'
  const paymentRequired = t
    ? t('cartesAcces.recherche.billing.paymentRequired')
    : 'Configurez au moins un mode de paiement.'

  if (useHotelBilling) {
    if (!draft.billing_client_kind) err.billing_client_kind = required
    if (!draft.billing_client_id) err.billing_client_id = selectClient
    if (!draft.billing_nom?.trim()) err.billing_nom = required
    if (draft.billing_client_kind === 'morale') {
      if (!draft.billing_matricule_fiscal?.trim()) err.billing_matricule_fiscal = required
      if (!draft.billing_adresse_facturation?.trim()) err.billing_adresse_facturation = required
      if (!skipPayment && !hasConfiguredTransferPayment(draft)) {
        err.payment_methods = paymentRequired
      }
    }
    return err
  }

  if (!skipPayment && isPartnerOrAffilieUser() && !hasConfiguredTransferPayment(draft)) {
    err.payment_methods = paymentRequired
  }
  if (!resolveClientName(draft)) err.client_name = required
  return err
}

export const buildCaReservationPayload = (carte, draft, { date, pax, total, isAcces }) => {
  const code = String(draft.phone_country_code || '+216').trim()
  const local = String(draft.billing_telephone || draft.client_phone || '').trim()
  let clientPhone = null
  if (local) {
    clientPhone = local.startsWith('+') ? local : `${code}${local.replace(/^0+/, '')}`
  }

  return {
    id_carte: carte.id,
    carte_label: carte.label,
    carte_type: carte.type,
    id_facility: carte.id_facility,
    facility_label: carte.facility_label,
    reservation_date: isAcces
      ? (hasDailyStock(carte) ? date || null : null)
      : date || null,
    reservation_time: null,
    pax: isAcces
      ? (carte.pricing_type === 'per_pax' ? pax : 1)
      : pax,
    price_total: total,
    amount: total,
    client_name: resolveClientName(draft),
    client_email: String(draft.billing_email || draft.client_email || '').trim() || null,
    client_phone: clientPhone,
    phone_country_code: draft.phone_country_code || '+216',
    client_type: draft.client_type || 'b2c',
    payment_method: serializeTransferPaymentMethod(draft),
    status: 'pending',
    channel: 'Cartes accès',
    ...resolveTransferBillingIds(draft),
  }
}

export const EMPTY_BILLING_DRAFT = {
  billing_client_kind: null,
  billing_client_id: null,
  billing_partner_id: null,
  billing_nom: '',
  billing_prenom: '',
  billing_email: '',
  billing_telephone: '',
  billing_adresse_facturation: '',
  billing_matricule_fiscal: '',
  phone_country_code: '+216',
  client_name: '',
  client_email: '',
  client_phone: '',
  client_type: 'b2c',
  payment_methods: {},
  payment_bundle: null,
}
